import { AsyncPipe } from '@angular/common';
import { Component } from '@angular/core';
import {
  EmailTransactionLogStatus,
  SmsTransactionStatus,
} from '@fitness-force/enum';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
  selector: 'email-status',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './settlement-status.component.html',
})
export class SettlementStatusComponent {
  additionData: Observable<any> = new BehaviorSubject(null);
  columnData: Observable<any> = new BehaviorSubject(null);

  constructor() {}

  ngOnInit(): void {}
}
